export default __webpack_public_path__ + "static/media/message-circle.7796f8f5.svg";